(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[19750],{

/***/ 64757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_WireframesSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx + 1 modules
var SectionTitle = __webpack_require__(36837);
// EXTERNAL MODULE: ./UI/components/Wireframes/index.jsx + 2 modules
var Wireframes = __webpack_require__(78677);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/sections/WireframesSection/styles.module.scss
var styles_module = __webpack_require__(67564);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/WireframesSection/utils/useWireframesSection.js




var useWireframesSection = function(param) {
    var section = param.section, data = param.data, type = param.type;
    var ref = (0,helper/* getDocumentFields */.OA)(data || section, [
        "title",
        "subtitle",
        "description",
        "images",
        "view", 
    ], {
        isNormilized: data
    }), title = ref.title, subtitle = ref.subtitle, description = ref.description, images = ref.images, view = ref.view;
    var sectionBackgroundImage = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(data, "background", {})), {
        fm: "png"
    });
    var sectionProps = {
        style: sectionBackgroundImage ? {
            backgroundImage: "url(".concat(sectionBackgroundImage, ")")
        } : {},
        className: classnames_default()((styles_module_default())[type], (styles_module_default())[view], (styles_module_default()).container)
    };
    return {
        type: type,
        view: view,
        title: title,
        images: images,
        subtitle: subtitle,
        description: description,
        sectionProps: sectionProps
    };
};

;// CONCATENATED MODULE: ./UI/sections/WireframesSection/index.jsx









var WireframesSection = function(props) {
    var ref = useWireframesSection(props), type = ref.type, view = ref.view, title = ref.title, images = ref.images, description = ref.description, subtitle = ref.subtitle, sectionProps = ref.sectionProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                subtitle: subtitle,
                description: description,
                type: type,
                titleStyle: (styles_module_default()).titleStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wireframes/* default */.Z, {
                images: images,
                type: type,
                view: view
            })
        ]
    }));
};
WireframesSection.prototype = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_WireframesSection = (WireframesSection);


/***/ }),

/***/ 67564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aw_1N","titleStyle":"styles_titleStyle__ePgGy","stickerbox":"styles_stickerbox__Xw87A","fairy":"styles_fairy__1QZty","fireaway":"styles_fireaway__Bk4HP","seven-pm-thursday":"styles_seven-pm-thursday__BU9eg","fernwayer":"styles_fernwayer__C1ZKC","open-sense":"styles_open-sense__asNoo","separate-us":"styles_separate-us__QNULL","famlicious":"styles_famlicious__1guC6","drive-focus":"styles_drive-focus__oEqif","travel-trivia":"styles_travel-trivia__MPcaQ","tell":"styles_tell__TOZf6","cash-chat":"styles_cash-chat__LXfad","ubichat":"styles_ubichat__0eUdZ","meateater":"styles_meateater__R_CjR","bionorica":"styles_bionorica__7_Xk3","fusion-markets":"styles_fusion-markets__Ct_XJ","beautonomy":"styles_beautonomy__KfBgs","image":"styles_image__QiXOA","telemojo":"styles_telemojo__eNYp_","blackbird":"styles_blackbird__SD8Ic","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__71Av5","dindon":"styles_dindon__Y7b3x","mobile-bank-application":"styles_mobile-bank-application__3Yv7f","humankind":"styles_humankind__CAU9R","titleStyles":"styles_titleStyles__LKr2d","forex-trading-platform":"styles_forex-trading-platform__E_nAq","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__itSCb","mobile-music-app":"styles_mobile-music-app__kWvnB","firstSectionView":"styles_firstSectionView__aFCYe","secondSectionView":"styles_secondSectionView__xMNq9","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__Mr8cV","ai-software-development-services":"styles_ai-software-development-services__gVw_v"};

/***/ })

}]);